const todoFilters = {
  assignedToUserId: null,
  targetDate: null,
  complete: null,
  onlyMyTasks: null
}

export default () => Object.assign({}, todoFilters)
